import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import UserList from '../views/UserList.vue'
import PostList from '../views/PostList.vue'
import CommentList from '../views/CommentList.vue'
import BadgeManage from '../views/BadgeManage.vue'
import CoachManage from '../views/CoachManage.vue'
import SiteConfig from '../views/SiteConfig.vue'



Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', component: Login },
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      { path: 'user', component: UserList },
      { path: 'post', component: PostList },
      { path: 'comment', component: CommentList },
      { path: 'badge', component: BadgeManage },
      { path: 'coach', component: CoachManage },
      { path: 'siteconfig', component: SiteConfig }

    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 简单路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) next('/login')
  else next()
})

export default router
